module.exports = __webpack_public_path__ + "img/error-dark.4239dc43.svg";